"use client";

import React from "react";
import GenericLazyLoader from "@/components/common/generic-lazy-loader";

interface FeaturedTourProps {
  tourCarousel: {
    currencyId?: string;
    landingPageId?: string;
    marketId?: string;
    featureCardDetails?: any;
  };
}

const LazyLoadFeaturedTourSection = ({ tourCarousel }: FeaturedTourProps) => (
  <GenericLazyLoader
    importComponent={() => import("../featured-tour/featured-tour")}
    componentProps={{ tourCarousel }}
    debugName="Featured Tour Section"
    threshold={0.1}
    rootMargin="200px 0px"
  />
);

export default LazyLoadFeaturedTourSection;
